<spacer [size]="16"></spacer>
<app-error *ngIf="formattedUnknownCarrierLoads?.length > 0">
    <i class="fa fa-warning"></i>
    <div class="text">
        <strong><span [i18n]="'bluechat.search.unknown-carriers.title'"></span></strong>
        <spacer [size]="8"></spacer>
        <ul>
            <ng-container *ngFor="let unknownCarrierLoad of formattedUnknownCarrierLoads">
                <li><span [i18n]="'bluechat.search.unknown-carriers.carrier'"></span>&nbsp;{{unknownCarrierLoad}}</li>
            </ng-container>
        </ul>
    </div>
</app-error>
